import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import StateChallanInfoCard from "../state-challan-info-card";

const StateEChallanOnlinePayment = ({ howToPayStateChallanData }) => {

    const { tokens } = useTokens();

    const { title = "", description = "", howToPayStateChallanList = [] } = howToPayStateChallanData || {};

    return (
        <div styleName={"styles.container"}>
            <Text size="400" fontWeight="semibold" color={tokens.text_default_text_primary} as="h2">{title}</Text>
            <Text size="250" fontWeight="regular" color={tokens.text_default_text_secondary}>{description}</Text>
            <div styleName={"styles.boxWrapper"}>
                {
                    howToPayStateChallanList.map((item, index) => {
                        if (item?.sectionData?.length === 0) return null;
                        return (
                            <StateChallanInfoCard key={index} title={item?.title} list={item?.sectionData} showImage={index !== 0} isCarsLogo={index === 0} />
                        );
                    })
                }
            </div>
        </div>
    );
};

StateEChallanOnlinePayment.propTypes = {
    howToPayStateChallanData: PropTypes.object
};

export default StateEChallanOnlinePayment;
